import { memo } from "react";
import { Image } from "expo-image";
import { StyleSheet } from "react-native-unistyles";

type VideoThumbnailOverlayProps = {
  thumbnailUrl: string;
};

export const VideoThumbnailOverlay = memo(({ thumbnailUrl }: VideoThumbnailOverlayProps) => {
  return <Image source={{ uri: thumbnailUrl }} style={styles.thumbnailImage} contentFit="cover" />;
});

const styles = StyleSheet.create((theme) => ({
  thumbnailImage: {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 1,
    borderRadius: theme.spacing.md,
  },
}));
